const school = {
  state: {
    school_name: window.sessionStorage.getItem('school_name'),
    school_logo: window.sessionStorage.getItem('school_logo') ? window.sessionStorage.getItem('school_logo') : '/static/logo.png'
  },
  mutations: {
    SET_SCHOOL_NAME (state, value) {
      window.sessionStorage.setItem('school_name', value)
      state.school_name = value
    },
    SET_SCHOOL_LOGO (state, value) {
      window.sessionStorage.setItem('school_logo', value)
      state.school_logo = value
    }
  },
  actions: {}
}

export default school



// WEBPACK FOOTER //
// ./src/store/modules/school.js